<template>
  <div :id="position + '-wrapper'" class="fab-wrapper" v-on-clickaway="away"
    :style="[ pos, {zIndex: zIndex}, {position: positionType} ]">
    <div :id="position + '-action'" class="actions-container" :style="listPos">
      <transition name="fab-actions-appear"
        :enter-active-class="transitionEnter"
        :leave-active-class="transitionLeave">
        <ul v-show="toggle" class="fab-list flex column items-center">
          <template v-for="action in actions">
            <transition
              enter-active-class="animated quick zoomIn"
              leave-active-class="animated quick zoomOut">
              <template v-if="action.tooltip">
                <li v-if="toggle" :style="{ 'background-color': action.color || bgColor }"
                  v-tooltip="{ content: action.tooltip, placement: tooltipPosition, classes: 'fab-tooltip', trigger: tooltipTrigger}"
                  @click="toParent(action.name)" class="pointer flex items-center"
                  ref="actions">
                  <i v-if="iconType === 'material-icons'" :class="[ actionIconSize ,'material-icons']">{{action.icon}}</i>
                  <i v-if="iconType === 'font-awesome'" :class="['fa', 'fa-' + action.icon, actionIconSize]" aria-hidden="true"></i>
                </li>
              </template>
              <template v-else>
                <li v-if="toggle" :style="{ 'background-color': action.color || bgColor }"
                  @click="toParent(action.name)" class="pointer">
                  <i v-if="iconType === 'material-icons'" :class="[ actionIconSize ,'material-icons']">{{action.icon}}</i>
                  <i v-if="iconType === 'font-awesome'" :class="['fa', 'fa-' + action.icon, actionIconSize]" aria-hidden="true"></i>
                </li>
              </template>
            </transition>
          </template>
        </ul>
      </transition>
    </div>
    <template v-if="rippleShow">
      <template v-if="mainTooltip">
        <div @click="toggle = !toggle"
          v-tooltip="{ content: mainTooltip, placement: tooltipPosition, classes: 'fab-tooltip' }"
          class="fab flex justify-center items-center pointer" :style="{ 'background-color': bgColor, 'padding': paddingAmount }">
          <i :class="[ mainIconSize , { rotate: toggle } ,'material-icons main']">{{mainIcon}}</i>
          <i :class="[ mainIconSize , { rotate: toggle } ,'material-icons close']">add</i>
        </div>
      </template>
      <template v-else>
        <div @click="toggle = !toggle"
          class="fab flex justify-center items-center pointer" :style="{ 'background-color': bgColor, 'padding': paddingAmount }">
          <i :class="[ mainIconSize , { rotate: toggle }, 'material-icons main']">{{mainIcon}}</i>
          <i :class="[ mainIconSize , { rotate: toggle }, 'material-icons close']">add</i>
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="mainTooltip">
        <div v-bind:v-tooltip="{ content: mainTooltip, placement: tooltipPosition, classes: 'fab-tooltip'}"
          class="fab flex justify-center items-center pointer" :style="{ 'background-color': bgColor, 'padding': paddingAmount }">
          <i class="material-icons md-36 main" :class="{ rotate: toggle }">{{mainIcon}}</i>
          <i class="material-icons md-36 close" :class="{ rotate: toggle }">add</i>
        </div>
      </template>
      <template v-else>
        <div class="fab flex justify-center items-center pointer" :style="{ 'background-color': bgColor, 'padding': paddingAmount }">
          <i class="material-icons md-36 main" :class="{ rotate: toggle }">{{mainIcon}}</i>
          <i class="material-icons md-36 close" :class="{ rotate: toggle }">add</i>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import Ripple from 'vue-ripple-directive'
import {VTooltip} from 'v-tooltip'

// VTooltip.enabled = window.innerWidth > 768

export default {
  mixins: [clickaway],
  directives: {Ripple, tooltip: VTooltip},
  data () {
    return {
      toggle: false,
      pos: {},
      tooltipPosition: 'left'
    }
  },
  props: {
    bgColor: {default: '#333333'},
    position: {default: 'bottom-right'},
    positionType: {default: 'fixed'},
    zIndex: {default: '999'},
    rippleShow: {default: true},
    rippleColor: {default: 'light'},
    mainIcon: {default: 'add'},
    iconSize: {default: 'medium'},
    mainTooltip: {default: null},
    fixedTooltip: {default: false},
    actions: {},
    fontFamily: {default: 'material-icons'}
  },
  computed: {
    actionIconSize () {
      switch (this.iconSize) {
        case 'small':
          return 'md-18'
        case 'medium':
          return 'md-24'
        case 'large':
          return 'md-36'
        default:
          return 'md-24'
      }
    },
    mainIconSize () {
      switch (this.iconSize) {
        case 'small':
          return 'md-24'
        case 'medium':
          return 'md-36'
        case 'large':
          return 'md-48'
        default:
          return 'md-36'
      }
    },
    paddingAmount () {
      switch (this.iconSize) {
        case 'small':
          return '28px'
        case 'medium':
          return '32px'
        case 'large':
          return '38px'
        default:
          return '32px'
      }
    },
    listPos () {
      if (this.position === 'top-right' || this.position === 'top-left') {
        return {
          top: '-20px',
          paddingTop: '20px'
        }
      }
      return {
        bottom: '-20px',
        paddingBottom: '20px'
      }
    },
    transitionEnter () {
      let animation = this.animation
      return animation.enter
    },
    transitionLeave () {
      let animation = this.animation
      return animation.leave
    },
    animation () {
      if (this.position === 'top-right' || this.position === 'top-left') {
        return {
          enter: 'animated quick fadeInDown',
          leave: 'animated quick fadeOutUp'
        }
      } else if (this.position === 'bottom-right' || this.position === 'bottom-left') {
        return {
          enter: 'animated quick fadeInUp',
          leave: 'animated quick fadeOutDown'
        }
      } else {
        return {
          enter: 'animated fadeInUp',
          leave: 'animated fadeOutDown'
        }
      }
    },
    tooltipTrigger () {
      if (this.fixedTooltip) {
        return 'manual'
      }
      return 'hover'
    },
    iconType () {
      if (this.fontFamily) {
        return this.fontFamily
      }
      return this.fontFamily.default
    }
  },
  methods: {
    tooltipPos () {
      if (this.position === 'top-right' || this.position === 'bottom-right') {
        this.tooltipPosition = 'left'
      } else {
        this.tooltipPosition = 'right'
      }
    },
    toParent (name) {
      this.$emit(name)
      this.toggle = false
    },
    away () {
      this.toggle = false
    },
    setPosition () {
      this.pos = {}
      switch (this.position) {
        case 'bottom-right':
          this.pos.right = '5vw'
          this.pos.bottom = '4vh'
          break
        case 'bottom-left':
          this.pos.left = '5vw'
          this.pos.bottom = '4vh'
          break
        case 'top-left':
          this.pos.left = '5vw'
          this.pos.top = '4vh'
          break
        case 'top-right':
          this.pos.right = '5vw'
          this.pos.top = '4vh'
          break
        default:
          this.pos.right = '5vw'
          this.pos.bottom = '4vh'
      }
    },
    moveTransition () {
      let wrapper = document.getElementById(this.position + '-wrapper')
      let el = document.getElementById(this.position + '-action')

      if (this.position === 'top-right' || this.position === 'top-left') {
        wrapper.appendChild(el)
      } else {
        wrapper.insertBefore(el, wrapper.childNodes[0])
      }
    },
    showTooltip (show) {
      if (show && this.$refs.actions && this.fixedTooltip) {
        // timeout to prevent wrong position for the tooltip
        setTimeout(() => {
          this.$refs.actions.forEach((item) => {
            if (this.toggle) {
              item._tooltip.show()
            }
          })
        }, 700)
      }
    }
  },
  watch: {
    position (val) {
      this.setPosition()

      this.$nextTick(() => {
        this.moveTransition()
        this.tooltipPos()
      })
    },
    toggle (val) {
      this.showTooltip(val)
    }
  },
  mounted () {
    this.moveTransition()
  },
  created () {
    this.setPosition()
  }
}
</script>

<style lang="scss">
.fab {
  &-tooltip {
    &.tooltip {
      display: none !important;
@media (min-width: 1025px) {
      display: block !important;
}
      padding: 4px;
      z-index: 10000;
      & .tooltip {
        &-inner {
          background: #333333;
          color: white;
          border-radius: 0px;
          padding: 5px 10px 4px;
        }
        &-arrow {
          display: none;
        }
      }
      &[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
      }
      &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
ul {
  list-style-type: none;
  padding: 0 !important;
}

.pointer {
  cursor: pointer;
}

.animated.quick {
  -webkit-animation-duration: .7s !important;
  animation-duration: .7s !important;
}

.fab {
  border-radius: 100px;
  // width: 65px;
  // height: 65px;
  padding: 30px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.20), 0 4px 4px rgba(0, 0, 0, 0.15);
  z-index: 2;
  &-wrapper {
    z-index: 999;
    & .actions-container {
      overflow: hidden;
      z-index: 0;
      position: relative;
    }
  }
  & .material-icons,
  & .fa {
    color: white;
    -webkit-transition: .4s all;
    -moz-transition: .4s all;
    transition: .4s all;
    margin: 0px auto;
    &.main {
      opacity: 1;
      position: absolute;
      &.rotate {
        -ms-transform: rotate(315deg); // IE 9
        -webkit-transform: rotate(315deg); // Chrome, Safari, Opera
        transform: rotate(315deg);
        opacity: 0;
        -webkit-transition: opacity .3s ease-in, -webkit-transform .4s; // Safari
        transition: opacity .3s ease-in, transform .4s;
      }
    }
    &.close {
      opacity: 0;
      position: absolute;
      &.rotate {
        -ms-transform: rotate(315deg); // IE 9
        -webkit-transform: rotate(315deg); // Chrome, Safari, Opera
        transform: rotate(315deg);
        opacity: 1;
        -webkit-transition: opacity .3s ease-in, -webkit-transform .4s; // Safari
        transition: opacity .3s ease-in, transform .4s;
      }
    }
  }
  &-list {
    position: relative;
    z-index: 1;
    margin: 2vh 0;
    & li {
      // width: 50px;
      // height: 50px;
      padding: 10px;
      margin-top: 2vh;
      border-radius: 100px;
      box-shadow: 0 10px 10px rgba(0, 0, 0, 0.20), 0 4px 4px rgba(0, 0, 0, 0.15);
      & .material-icons,
      & .fa {
        color: white;
        margin: 0px auto;
      }
    }
  }
}

.material-icons {
  // Rules for sizing the icon.
  &.md-18 {
    font-size: 18px;
  }
  &.md-24 {
    font-size: 24px;
  }
  &.md-36 {
    font-size: 36px;
  }
  &.md-48 {
    font-size: 48px;
  }
  // Rules for using icons as black on a light background.
  &.md-dark {
    color: rgba(0, 0, 0, 0.54);
    &.md-inactive {
        color: rgba(0, 0, 0, 0.26);
    }
  }
  // Rules for using icons as white on a dark background.
  &.md-light {
    color: rgba(255, 255, 255, 1);
    &.md-inactive {
      color: rgba(255, 255, 255, 0.3);
    }
  }
}

.fa {
  text-align: center;
  &.md-18 {
    width: 18px;
    font-size: 18px;
  }
  &.md-24 {
    width: 24px;
    font-size: 24px;
  }
  &.md-36 {
    width: 36px;
    font-size: 36px;
  }
  &.md-48 {
    width: 48px;
    font-size: 48px;
  }
}

@media screen and (max-width: 768px) {
  .fab {
    // width: 55px;
    // height: 55px;
    // padding: 1.5rem;
    &-list {
      margin: 2vh 0;
      & li {
        // width: 40px;
        // height: 40px;
        // padding: .6rem;
        & i {
          // font-size: 24px !important;
        }
      }
    }
    & i {
      // font-size: 34px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/FAB.vue